import React, { PureComponent } from 'react'

export default class Home extends PureComponent {
  render() {
    return (
      <div>
        
        <h1  className='display-1 alert'>Home</h1>
      </div>

      
    )
  }
}
